// extracted by mini-css-extract-plugin
export default {"loader":"styles-module__loader___eMlXH","blured-background":"styles-module__blured-background___FxlZB","topic":"styles-module__topic___i9WjF"};